"use client";

import { useTranslations } from "next-intl";
import {
    List,
    ListItem,
    ListItemAvatar,
    ListItemButton,
    ListItemText,
    Popover,
} from "@/components/controls/base-controls";
import { BusinessCenterIcon, FlightTakeoffIcon, PeopleIcon  } from "@/components/controls/icons";
import { SignIn, type SignInType  } from "@/core/types/sign-in.type";
import { Link } from "@/i18n/navigation";

type SignInPopoverProps = {
    allowedValues: readonly SignInType[];
    anchorEl: HTMLElement | null;
    open: boolean;
    onClose: () => void;
};

const SignInPopover = (props: SignInPopoverProps) => {
    const { allowedValues, anchorEl, open, onClose } = props;

    const t = useTranslations();

    const getIcon = (item: SignInType) => {
        switch (item.label) {
            case SignIn.broker.label:
                return <BusinessCenterIcon />;
            case SignIn.operator.label:
                return <FlightTakeoffIcon />;
           case SignIn.traveler.label:
                return <PeopleIcon />;
            default:
                return <PeopleIcon />;
        }
    }

    return (
        <Popover
            open={open}
            anchorEl={anchorEl}
            onClose={onClose}
            anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
            transformOrigin={{ vertical: "top", horizontal: "left" }}
            slotProps={{ paper: { sx: { width: "14em", mt: "8px" } } }}
            sx={{ fontSize: ".875em" }}
        >
            <List sx={{ p: 0 }}>
                {allowedValues.map((item) => (
                    <ListItem key={item.label} disablePadding>
                        <ListItemButton component={Link} href={item.link}
                            sx={{ px: ".4em"  }}>
                            <ListItemAvatar sx={{ minWidth: "unset", mr: 1 }}>
                                {getIcon(item)}
                            </ListItemAvatar>
                            <ListItemText primary={t(`sign_in.${item.label}`)} sx={{ flexGrow: 1 }} slotProps={{ primary: { variant: "body2" } }} />
                        </ListItemButton>
                    </ListItem>
                ))}
            </List>
        </Popover>
    );
};

export default SignInPopover;
